import { datasetAPI } from 'api/dataset';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { locales } from 'utils/constants';
import { QUERY_KEY } from 'utils/enums';

export function useCreateDataset() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: datasetAPI.create,
    onSuccess: (data) => {
      queryClient.setQueryData(QUERY_KEY.FIND_ONE_DATASET, data);
      toast(locales.createSuccess, { type: 'success' });
    },
  });

  return mutation;
}
